
import { defineComponent, PropType } from 'vue';

export interface CampaignMetricDisplay {
  id: string;
  label: string;
  value: string;
}

export default defineComponent({
  name: 'CampaignPerformanceMetrics',
  props: {
    metrics: {
      type: Array as PropType<CampaignMetricDisplay[]>,
      required: true,
      default: () => [],
    },
  },
});
